import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Header from "@components/Header";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { fetchAPI } from "@utils/https/fetchAPI";

import { OverviewChart } from "./OverviewChart";
import { OverviewHeader } from "./OverviewHeader";
import { OverviewTableView } from "./OverviewTableView";

// const data = {
//   labels: ["Image", "Video", "Audio"],
//   datasets: [
//     {
//       label: "Files",
//       data: [65, 40, 15],
//       backgroundColor: [
//         "rgba(75, 192, 192, 0.7)", // สีเขียว
//         "rgba(255, 205, 86, 0.7)", // สีเหลือง
//         "rgba(54, 162, 235, 0.7)", // สีน้ำเงิน
//       ],
//       borderWidth: 1,
//     },
//   ],
// };

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default () => {
  const authUserProfile = getAuthUserProfile();
  const [overviewHeaderData, setOverviewHeaderData] = useState(null);
  const [overviewChartData, setOverviewChartData] = useState(null);
  const [overviewTableViewData, setOverviewTableViewData] = useState(null);
  const category_customer_id = _.get(authUserProfile, ["category_customer_id"]);
  const [listCustomers, setListCustomers] = useState([
    { label: "All", value: null },
  ]);

  const initData = async () => {
    console.log("category_customer_id :>> ", category_customer_id);
    const resp = await fetchAPI({
      method: "post",
      path: `/api/dashboard`,
      isAuth: true,
      data: {
        customer_id: category_customer_id ? [category_customer_id] : null,
      },
    });
    if (_.get(resp, ["status"])) {
      const result = _.get(resp, ["result"]);
      const overviewHeader = {
        ..._.pick(result, [
          "totalDevices",
          "totalCampaigns",
          "totalMedias",
          "totalProjects",
        ]),
      };
      const overviewChart = {
        ..._.pick(result, ["top10CampaignsByProject", "filesPerProject"]),
      };

      const overviewTableView = {
        ..._.pick(result, ["diskQuota", "customerTableView"]),
      };
      setOverviewTableViewData(overviewTableView);
      setOverviewChartData(overviewChart);
      setOverviewHeaderData(overviewHeader);
      console.log("overviewHeader :>> ", overviewHeader);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: 240 }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ gap: 16, overflow: "scroll" }}>
            <HeaderContainer>
              <Text fontSize={"20px"} fontWeight="600">
                Overview
              </Text>
              {/* <Select
                showSearch
                optionFilterProp="children"
                style={{ width: "300px" }}
                options={listCustomers}
                defaultValue={defaultSelectedCustomer}
                // onChange={(value) => {
                //   onHandleChangeValue({
                //     key: ["attribute", "objectFit"],
                //     value,
                //   });
                // }}
              /> */}
            </HeaderContainer>
            <OverviewHeader overviewHeaderData={overviewHeaderData} />
            <OverviewChart overviewChartData={overviewChartData} />
            <OverviewTableView overviewTableViewData={overviewTableViewData} />
          </InnerContents>
        </Content>
      </Layout>
    </Layout>
  );
};
